import {http, onSuccess, onFail} from '../player/http';

export const widgetRegistrationSave = (id, data) =>
    http.post(`/api/cp/event/${id}/module/widget`, data)
        .then(onSuccess, onFail);

export const getWidgetsRegistration = (eventKey) => {
    return http.get(`/api/cp/event/${eventKey}/module/widget/registration`)
        .then(onSuccess, onFail);
};

export const createWidgetRegistration = (eventKey) => {
    return http.post(`/api/cp/event/${eventKey}/module/widget/registration`)
        .then(onSuccess, onFail);
};

export const updateWidgetRegistration = (widgetKey, payload) => {
    return http.post(`/api/cp/event/module/widget/registration/${widgetKey}`, payload)
        .then(onSuccess, onFail);
};

export const deleteWidgetRegistration = (widgetKey) => {
    return http.delete(`/api/cp/event/module/widget/registration/${widgetKey}`)
        .then(onSuccess, onFail);
};

export const updateWidgetRegistrationFieldsOrder = (widget, payload) => {
    return http.post(`/api/cp/event/module/widget/registration/${widget}/registration-fields-order`, {sortOrder: payload})
        .then(onSuccess, onFail);
};

export const updateWidgetRegistrationField = (field, payload) => {
    return http.post(`/api/cp/event/module/widget/registration/fields/${field}`, payload)
        .then(onSuccess, onFail);
};
